import { FC } from 'react'
import { TruncatedTooltip } from 'src/components/TruncatedTooltip'
import styles from './comparingCampaigns.module.scss'
import { MultiCampaign } from '../interfaces'
import { campaignColor } from '../palette'

interface ComparingCampaignsProps {
  campaigns: MultiCampaign[]
}

const COPY = {
  title: 'Comparing',
}

// The page's key: which campaigns are in this report and what colour each one
// is wearing in every chart below. With four series on a line chart the legend
// alone is not enough — the reader needs one place that states the pairing.
export const ComparingCampaigns: FC<ComparingCampaignsProps> = ({
  campaigns,
}) => (
  <section className={styles.card}>
    <h3 className={styles.title}>{COPY.title}</h3>

    <ul className={styles.chips}>
      {campaigns.map((campaign, index) => (
        <li
          className={styles.chip}
          key={campaign.id}
          style={{ borderColor: campaignColor(index) }}
        >
          <span
            className={styles.dot}
            style={{ background: campaignColor(index) }}
          />
          {/* Two lines, then an ellipsis and the whole name on hover — the
              longest campaign names in the account run past three lines, and a
              chip that grows to hold one makes the row ragged. */}
          <TruncatedTooltip
            className={styles.name}
            maxLines={2}
            text={campaign.name}
          />
        </li>
      ))}
    </ul>
  </section>
)
